export enum AuthUserTypeEnum {
  REGULAR = "regular",
  SHARED = "shared",
}
